module.exports = __webpack_public_path__ + "assets/ca29f9cf3310ecb8f1d4963292ee3994.mp3";